import {IPopUpState} from '../../../api/popUp/types';

export const selectPopUp = (state: IPopUpState) => state.popUp.data;
